<ul
	ngTree
	class="flex flex-col gap-y-1 px-3 py-3"
	[nav]="true"
	#tree="ngTree"
>
	<ng-template
		[ngTemplateOutlet]="treeNodes"
		[ngTemplateOutletContext]="{
			nodes: navigation(),
			parent: tree
		}"
	></ng-template>
</ul>

<ng-template
	let-nodes="nodes"
	let-parent="parent"
	#treeNodes
>
	<ng-container *ngFor="let node of nodes; trackBy: trackById">
		<a
			cdkMonitorElementFocus
			ngTreeItem
			routerLinkActive="bg-white/15 !text-white"
			class="navigation-item flex cursor-pointer select-none items-center gap-x-3 rounded-md px-4 py-2.5 text-md font-medium text-white/80 hover:bg-white/15 hover:text-white"
			[parent]="parent"
			[value]="node.id"
			[label]="node.label"
			[disabled]="node.disabled ?? false"
			[selectable]="!node.children"
			[(expanded)]="node.expanded"
			[routerLink]="node.route"
			[routerLinkActiveOptions]="node.activeOptions ?? { exact: true }"
			(click)="$event.preventDefault()"
			#treeItem="ngTreeItem"
		>
			<!-- Icon -->
			<mat-icon
				*ngIf="node.icon"
				class="pointer-events-none text-current icon-size-4"
				fontSet="fas"
				[fontIcon]="node.icon"
			></mat-icon>

			<!-- Label -->
			<div class="flex-auto truncate">
				{{ node.label }}
			</div>

			<!-- Badge -->
			<div
				*ngIf="node.badge"
				class="rounded bg-accent-500 px-1.5 py-0.5 text-xs font-semibold"
			>
				{{ node.badge }}
			</div>

			<!-- Expand icon -->
			<mat-icon
				*ngIf="node.children && node.children.length > 0"
				class="pointer-events-none text-current transition-transform icon-size-3"
				fontSet="fas"
				fontIcon="fa-chevron-right"
				[class.rotate-90]="node.expanded"
			></mat-icon>
		</a>

		<!-- Children -->
		<ul
			*ngIf="node.children && node.children.length > 0"
			class="flex flex-col gap-y-1 [&>.navigation-item]:pl-9"
			role="group"
			[class.hidden]="!node.expanded"
			[class.mt-1]="node.expanded"
		>
			<ng-template
				ngTreeItemGroup
				[ownedBy]="treeItem"
				#group="ngTreeItemGroup"
			>
				<ng-template
					[ngTemplateOutlet]="treeNodes"
					[ngTemplateOutletContext]="{
						nodes: node.children,
						parent: group
					}"
				></ng-template>
			</ng-template>
		</ul>
	</ng-container>
</ng-template>
